var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 147.013,
    height: 38.412,
    viewBox: "0 0 147.013 38.412",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1018",
    "data-name": "Group 1018",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M164.645,1009.074a27.615,27.615,0,0,1-2.5,4.659c-1.621,2.467-3.905,5.54-6.735,5.566-2.516.023-3.161-1.637-6.574-1.619s-4.126,1.648-6.642,1.625c-2.83-.026-4.995-2.8-6.616-5.268-4.532-6.9-5.006-15-2.211-19.3a10.029,10.029,0,0,1,8.066-4.849c3,0,4.886,1.645,7.366,1.645,2.406,0,3.872-1.647,7.34-1.647a9.788,9.788,0,0,1,7.379,3.9A8.444,8.444,0,0,0,164.645,1009.074Z",
    transform: "translate(-131.637 -980.893)",
    fill: "#97999b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007",
    transform: "translate(15.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M186.219,968.591a8.42,8.42,0,0,0,1.87-6.236,9.1,9.1,0,0,0-5.872,3.159A7.817,7.817,0,0,0,180.3,971.6,7.678,7.678,0,0,0,186.219,968.591Z",
    transform: "translate(-180.207 -962.355)",
    fill: "#97999b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019",
    transform: "translate(40.323 0.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1009",
    "data-name": "Group 1009",
    transform: "translate(0 13.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M261.574,1004.42l-6.492,19.11h2.973l1.938-5.868h6.286l1.993,5.868h3.055l-6.52-19.11Zm1.54,3.142c.219.853.456,1.739.76,2.7l1.75,5.067h-4.979l1.725-5.1C262.633,1009.4,262.882,1008.5,263.115,1007.562Z",
    transform: "translate(-255.082 -1004.115)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M315.37,1019.586a5.41,5.41,0,0,0-4.6,2.205l-.115-1.9h-2.645l.016.243c.078,1.184.11,2.487.11,4.359v14.73h2.892v-6.874a5.077,5.077,0,0,0,3.952,1.7,5.96,5.96,0,0,0,4.381-1.863,7.9,7.9,0,0,0,1.934-5.561,7.692,7.692,0,0,0-1.68-5.078A5.5,5.5,0,0,0,315.37,1019.586Zm-.72,2.394c2.578,0,3.731,2.388,3.731,4.754,0,3.052-1.472,4.948-3.841,4.948a3.5,3.5,0,0,1-3.406-2.683,3.688,3.688,0,0,1-.1-.936v-2.325a4.348,4.348,0,0,1,.092-.714c.014-.079.03-.158.042-.234A3.661,3.661,0,0,1,314.65,1021.979Z",
    transform: "translate(-290.724 -1014.327)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M360.952,1019.586a5.413,5.413,0,0,0-4.6,2.205l-.115-1.9H353.6l.015.243c.078,1.185.111,2.487.111,4.359v14.73h2.891v-6.874a5.075,5.075,0,0,0,3.951,1.7,5.968,5.968,0,0,0,4.383-1.863,7.908,7.908,0,0,0,1.934-5.561,7.693,7.693,0,0,0-1.681-5.078A5.5,5.5,0,0,0,360.952,1019.586Zm-.72,2.394c2.576,0,3.73,2.388,3.73,4.754,0,3.052-1.473,4.948-3.84,4.948a3.5,3.5,0,0,1-3.406-2.683,3.691,3.691,0,0,1-.1-.936v-2.325a4.29,4.29,0,0,1,.092-.716c.014-.078.029-.156.042-.232A3.659,3.659,0,0,1,360.232,1021.979Z",
    transform: "translate(-321.417 -1014.327)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M419.029,1011.89c-2.7-1.045-3.563-1.867-3.563-3.385,0-1.279,1.016-2.568,3.286-2.568a6.572,6.572,0,0,1,3.394.852l.245.151.816-2.413-.161-.094a8.379,8.379,0,0,0-4.21-.945c-3.687,0-6.262,2.177-6.262,5.292,0,2.513,1.613,4.269,5.075,5.528,2.454.917,3.367,1.857,3.367,3.467,0,1.823-1.409,2.954-3.675,2.954a7.913,7.913,0,0,1-4.168-1.182l-.251-.161-.776,2.469.143.094a9.906,9.906,0,0,0,4.886,1.256c4.969,0,6.731-3.03,6.731-5.625C423.905,1014.907,422.493,1013.257,419.029,1011.89Z",
    transform: "translate(-360.841 -1003.488)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M453.957,1010.439l-2.836.89v2.4h-2.076v2.311h2.076v7.078a5.41,5.41,0,0,0,1,3.668,3.706,3.706,0,0,0,2.8,1.1,6.819,6.819,0,0,0,2.235-.345l.162-.057-.138-2.315-.277.085a4.352,4.352,0,0,1-1.345.156c-1.12,0-1.6-.709-1.6-2.373v-6.995h3.488v-2.311h-3.488Z",
    transform: "translate(-385.688 -1008.169)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M482.532,1019.586c-4.045,0-6.87,3.02-6.87,7.341,0,4.193,2.734,7.12,6.649,7.12h.027c3.31,0,6.87-2.306,6.87-7.369a7.3,7.3,0,0,0-1.843-5.114A6.435,6.435,0,0,0,482.532,1019.586Zm-.083,2.283c2.6,0,3.785,2.536,3.785,4.893,0,2.9-1.616,5-3.84,5h-.028c-2.192,0-3.784-2.068-3.784-4.918C478.582,1024.369,479.778,1021.869,482.449,1021.869Z",
    transform: "translate(-403.61 -1014.327)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M529.408,1019.72l-.173-.044a2.786,2.786,0,0,0-.719-.091,4.126,4.126,0,0,0-3.625,2.328l-.085-2.023h-2.595l.017.243c.077,1.145.109,2.43.109,4.164l-.027,9.445H525.2v-7.369a7.44,7.44,0,0,1,.08-1.12,3.2,3.2,0,0,1,3.042-2.914,7.472,7.472,0,0,1,.776.048l.309.032Z",
    transform: "translate(-434.954 -1014.327)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M550.668,1019.5c-3.849,0-6.537,3.076-6.537,7.479,0,4.24,2.674,6.981,6.814,6.981a11.087,11.087,0,0,0,4.578-.878l.174-.078-.556-2.154-.241.1a8.969,8.969,0,0,1-3.622.647,4.02,4.02,0,0,1-4.331-4.192l9.332.029.037-.185a6.428,6.428,0,0,0,.087-1.207C556.4,1023.024,554.9,1019.5,550.668,1019.5Zm-.192,2.2a2.854,2.854,0,0,1,2.122.81,4.114,4.114,0,0,1,1,2.691H547C547.269,1023.534,548.313,1021.7,550.476,1021.7Z",
    transform: "translate(-449.714 -1014.271)",
    fill: "#ececec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M255.082,964.069a21.089,21.089,0,0,1,2.773-.187,6.189,6.189,0,0,1,4.071,1.114,3.959,3.959,0,0,1,1.432,3.261,4.578,4.578,0,0,1-1.447,3.516,6.709,6.709,0,0,1-4.458,1.3,20.041,20.041,0,0,1-2.371-.108Zm1.312,8.011a9.255,9.255,0,0,0,1.312.054c2.773.012,4.279-1.4,4.279-3.838.015-2.161-1.327-3.489-4.07-3.489a8.256,8.256,0,0,0-1.521.12Z",
    transform: "translate(-255.082 -963.465)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M287.523,978.23a3.26,3.26,0,0,1-3.459-3.341,3.35,3.35,0,0,1,3.578-3.449,3.234,3.234,0,0,1,3.474,3.328,3.362,3.362,0,0,1-3.578,3.462Zm.045-.886a2.311,2.311,0,0,0,2.192-2.536,2.207,2.207,0,1,0-2.207,2.536Z",
    transform: "translate(-274.597 -968.555)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M309.243,971.891l.969,3.288c.193.724.388,1.409.522,2.08h.045c.164-.658.4-1.355.641-2.066l1.178-3.3h1.1l1.118,3.247c.268.765.477,1.463.641,2.121h.045a17.982,17.982,0,0,1,.552-2.107l1.028-3.261h1.3l-2.326,6.495h-1.193l-1.1-3.1a21.319,21.319,0,0,1-.642-2.147h-.029a17.8,17.8,0,0,1-.657,2.161l-1.163,3.086h-1.193l-2.177-6.495Z",
    transform: "translate(-290.647 -968.858)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M343.888,973.346c0-.684-.015-1.221-.06-1.758h1.164l.074,1.06h.03a2.734,2.734,0,0,1,2.385-1.208,2.47,2.47,0,0,1,2.55,2.764v3.878H348.72v-3.744c0-1.047-.433-1.932-1.671-1.932a1.872,1.872,0,0,0-1.759,1.207,1.593,1.593,0,0,0-.09.55v3.918h-1.312Z",
    transform: "translate(-314.839 -968.555)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M369.346,962.607h1.312v9.527h-1.312Z",
    transform: "translate(-332.022 -962.607)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M381.891,978.23a3.26,3.26,0,0,1-3.459-3.341,3.35,3.35,0,0,1,3.578-3.449,3.234,3.234,0,0,1,3.474,3.328,3.363,3.363,0,0,1-3.578,3.462Zm.044-.886a2.311,2.311,0,0,0,2.193-2.536,2.207,2.207,0,1,0-2.207,2.536Z",
    transform: "translate(-338.14 -968.555)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M409.008,976.526a9.788,9.788,0,0,0,.1,1.556h-1.178l-.119-.818h-.044a2.774,2.774,0,0,1-2.207.966,1.967,1.967,0,0,1-2.207-1.865c0-1.57,1.55-2.429,4.338-2.416v-.134c0-.537-.163-1.516-1.64-1.5a3.765,3.765,0,0,0-1.894.483l-.3-.792a5.085,5.085,0,0,1,2.386-.563c2.222,0,2.758,1.355,2.758,2.657Zm-1.282-1.758c-1.431-.027-3.057.2-3.057,1.462a1.1,1.1,0,0,0,1.223,1.128,1.819,1.819,0,0,0,1.774-1.088,1.08,1.08,0,0,0,.06-.375Z",
    transform: "translate(-354.923 -968.555)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M432.25,962.607v7.85c0,.577.016,1.235.06,1.677h-1.178l-.06-1.127h-.03a2.7,2.7,0,0,1-2.445,1.275,3.1,3.1,0,0,1-3.1-3.3,3.238,3.238,0,0,1,3.235-3.489,2.482,2.482,0,0,1,2.178.98h.029v-3.865Zm-1.312,5.676a1.958,1.958,0,0,0-.06-.51,1.9,1.9,0,0,0-1.893-1.355,2.222,2.222,0,0,0-2.162,2.5,2.154,2.154,0,0,0,2.133,2.415,1.953,1.953,0,0,0,1.923-1.409,1.835,1.835,0,0,0,.06-.51Z",
    transform: "translate(-369.831 -962.607)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M464.379,978.23a3.26,3.26,0,0,1-3.459-3.341,3.351,3.351,0,0,1,3.578-3.449,3.234,3.234,0,0,1,3.475,3.328,3.363,3.363,0,0,1-3.578,3.462Zm.045-.886a2.311,2.311,0,0,0,2.191-2.536,2.206,2.206,0,1,0-2.206,2.536Z",
    transform: "translate(-393.684 -968.555)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M487.458,973.346c0-.684-.015-1.221-.06-1.758h1.163l.075,1.06h.029a2.734,2.734,0,0,1,2.385-1.208,2.47,2.47,0,0,1,2.55,2.764v3.878h-1.312v-3.744c0-1.047-.432-1.932-1.67-1.932a1.874,1.874,0,0,0-1.76,1.207,1.6,1.6,0,0,0-.089.55v3.918h-1.312Z",
    transform: "translate(-411.513 -968.555)",
    fill: "#ececec"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/appStore.d0187b87eaabde10d25b7780be00e76e.svg";
export { ForwardRef as ReactComponent };